"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.RichEditDocumentBaseApi = void 0;
var tslib_1 = require("tslib");
var json_top_level_enums_1 = require("../core/model/json/enums/json-top-level-enums");
var document_1 = require("../model-api/document");
var sub_documents_collection_1 = require("./collections/sub-documents-collection");
var RichEditDocumentBaseApi = (function (_super) {
    tslib_1.__extends(RichEditDocumentBaseApi, _super);
    function RichEditDocumentBaseApi(core) {
        var _this = _super.call(this, core) || this;
        _this._core = core;
        return _this;
    }
    Object.defineProperty(RichEditDocumentBaseApi.prototype, "modified", {
        get: function () { return this._core.getModifiedState() == json_top_level_enums_1.IsModified.True; },
        set: function (value) { if (!value)
            this._core.setModifiedFalse(); },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(RichEditDocumentBaseApi.prototype, "subDocuments", {
        get: function () {
            return new sub_documents_collection_1.SubDocumentCollectionBaseApi(this._core);
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(RichEditDocumentBaseApi.prototype, "bookmarks", {
        get: function () {
            return this.subDocuments.main.bookmarks;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(RichEditDocumentBaseApi.prototype, "images", {
        get: function () {
            return this.subDocuments.main.images;
        },
        enumerable: false,
        configurable: true
    });
    RichEditDocumentBaseApi.prototype.setDefaultCharacterProperties = function (characterProperties) {
        _super.prototype.setDefaultCharacterProperties.call(this, characterProperties);
        this._core.inputPosition.reset();
        this._core.barHolder.updateItemsState();
    };
    return RichEditDocumentBaseApi;
}(document_1.RichEditDocumentApi));
exports.RichEditDocumentBaseApi = RichEditDocumentBaseApi;
